<script setup lang="ts">
import chevronDown from '@/assets/svgs/chevron_down.svg'
import chevronUp from '@/assets/svgs/chevron_up.svg'
import BaseFilter from '@/components/base/BaseFilter.vue'
import { useIsMobile } from '@/composables/useMediaQuery'
import type { FilterOption } from '@/types/filter.types'

const props = defineProps<{
  programs: FilterOption[]
  selectedProgram?: FilterOption
}>()

const emit = defineEmits<{
  (e: 'program-select', programOption: FilterOption): void
}>()

const isMobile = useIsMobile()

const handleSelect = (option: FilterOption) => {
  emit('program-select', option)
}
</script>

<template>
  <BaseFilter
    :options="programs"
    :selectedOption="props.selectedProgram"
    :width="320"
    v-if="programs.length > 0 && props.selectedProgram"
    customTrigger
    @select="handleSelect"
  >
    <template #trigger="{ isOpen }">
      <div class="program-filter-trigger">
        <span class="title-md white" :class="{ 'title-sm': isMobile }">{{
          props.selectedProgram?.name
        }}</span>
        <img class="svg-24 svg-white" :src="isOpen ? chevronUp : chevronDown" alt="chevron" />
      </div>
    </template>
  </BaseFilter>
</template>

<style scoped>
.program-filter-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

@media (max-width: 1365px) {
  .program-filter-trigger {
    gap: 4px;
  }
}
</style>
